export default {
  init() {
    // Bind the changes of the elements
    $(document).on('change', '.variation-radios input', function() {
      // Update all the hidden select input when an input changes
      $('.variation-radios input:checked').each(function(index, element) {
        var $el = $(element);
        var thisName = $el.attr('name');
        var thisVal  = $el.attr('value');
        $('select[name="'+thisName+'"]').val(thisVal).trigger('change');
      });
    });

    $(document).on('click', '.variation-radios label', function(e) {
      // Give the option to untick the element.
      var $el = $(this);
      var $parent = $el.parent();
      var $input = $parent.find('input:checked');

      if($input.length) {
        e.preventDefault();
        $input.prop('checked', false);
        var thisName = $input.attr('name');
        $('select[name="'+thisName+'"]').prop('selectedIndex',0).trigger('change');
      }

    });

    // Disable radios that don't have a corresponding select option when a user updates an option.
    $(document).on('woocommerce_update_variation_values', function() {

      $('.variation-radios input').each(function(index, element) {
        var $el = $(element);
        var thisName = $el.attr('name');
        var thisVal  = $el.attr('value');
        $el.removeAttr('disabled');
        $el.parent('.is-disabled').removeClass('is-disabled');
        if($('select[name="'+thisName+'"] option[value="'+thisVal+'"]').length === 0) {
          $el.prop('disabled', true);
          $el.parent().addClass('is-disabled');
        }
      });
    });

    // Hide the select dropdown so it's the radios that replace them.
    $('.variation-radios').each(function(){
      // Find the parent
      const $el = $(this);
      const $parent = $el.parent();
      // Then the child select and hide it.
      const $select = $parent.children('select');
      $select.hide();
    });

    // When the fields are reset with the clear button
    $('.reset_variations').on('click.resetClicker', function() {
      $('.variation-radios').each(function(){
        const $el = $(this);
        const $radios = $el.find('input');
        $radios.prop('checked', false);
      });

      if($('body[class*="pre-made"]').length > 0 && $('input[value*="rebated"]').length > 0) {
        if($('input[value*="rebated"]').parent('.exp-radio-checkbox').siblings('.exp-radio-checkbox').length === 0) {
          $('input[value*="rebated"]').closest('.value').prop('style', 'pointer-events: none');
          $('input[value*="rebated"]').prop('checked', true);
        }
      }
    })

    setTimeout(() => {
      $('.woocommerce.single-product .variations_form.cart').addClass('is-ready');
    }, 400);
  },
}



// WEBPACK FOOTER //
// ./scripts/components/attribute-radios.js